// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31kMD","footer":"Form_footer__3gyHO"};